import { ArrowRight, Check, Clock3, LoaderCircle } from "lucide-react";
import type { MemberOffer } from "../../shared/types";
import { money } from "../../shared/domain";

interface Props {
  offer: MemberOffer;
  featured?: boolean;
  onStart(offer: MemberOffer): void;
  busy?: boolean;
}

export function OfferCard({ offer, featured, onStart, busy }: Props) {
  const disabled = offer.memberState === "pending" || offer.memberState === "completed" || offer.memberState === "earned";
  const label = offer.memberState === "started" ? "Continue" : offer.memberState === "pending" ? "Pending" : offer.memberState === "completed" ? "Completed" : offer.ctaLabel;
  return (
    <article className={`offer-card ${featured ? "featured-offer" : ""}`}>
      {featured && <span className="featured-label">BEST MATCH</span>}
      <div className="offer-topline">
        <div className="reward">+{money(offer.rewardCents)}</div>
        {offer.memberState === "completed" && <span className="state-pill earned"><Check size={14} /> Earned</span>}
        {offer.memberState === "pending" && <span className="state-pill pending"><LoaderCircle size={14} /> Pending</span>}
      </div>
      <h3>{offer.title}</h3>
      <p>{offer.shortDescription}</p>
      <div className="offer-meta">
        {offer.estimatedMinutes && <span><Clock3 size={15} /> ~{offer.estimatedMinutes} minutes</span>}
      </div>
      <div className="badges">
        {offer.badges.map((badge) => <span key={badge}>{badge}</span>)}
      </div>
      <button className="button offer-button" type="button" onClick={() => onStart(offer)} disabled={disabled || busy}>
        {busy ? "Opening…" : label}
        {!disabled && !busy && <ArrowRight size={18} />}
      </button>
      <details className="offer-terms">
        <summary>What counts</summary>
        <p>{offer.completionTerms}</p>
        <p>{offer.creditTimingCopy}</p>
      </details>
    </article>
  );
}
